export default __webpack_public_path__ + "static/media/creditKindReward.fa20429b.png";